import ROUTES from '../routes';
import OutgoingTransactions from '../hoc/outgoing/outgoing';
import OutgoingTransaction from '../hoc/outgoing/transaction';
import ExpandedGeneralLedgerTransaction from '../hoc/transactions/expanded-general-ledger-panel';

const OutgoingRoutes = {
  path: ROUTES.OUTGOING,
  element: <OutgoingTransactions />,
  children: [
    {
      path: ROUTES.OUTGOING_TRANSACTION,
      element: <OutgoingTransaction />,
    },
    {
      path: ROUTES.OUTGOING_TRANSACTION_CREATE,
      element: <OutgoingTransaction />,
    },
    {
      path: ROUTES.OUTGOING_TRANSACTION_GL,
      element: <ExpandedGeneralLedgerTransaction backLink={ROUTES.OUTGOING} />,
    },
  ],
};

export default OutgoingRoutes;
